import axios from "axios";
import Config from "../../config/index";

import {
  CREATE_TRANSACTION_FAILURE,
  CREATE_TRANSACTION_REQUEST,
  CREATE_TRANSACTION_SUCCESS,
  DOWNLOAD_COMPLETED_TRANSACTION_FAILURE,
  DOWNLOAD_COMPLETED_TRANSACTION_REQUEST,
  DOWNLOAD_COMPLETED_TRANSACTION_SUCCESS,
  DOWNLOAD_REJECTED_TRANSACTION_FAILURE,
  DOWNLOAD_REJECTED_TRANSACTION_REQUEST,
  DOWNLOAD_REJECTED_TRANSACTION_SUCCESS,
  DOWNLOAD_TRANSACTION_REQUEST,
  DOWNLOAD_TRANSACTION_SUCCESS,
  EDIT_TRANSACTION_FAILURE,
  EDIT_TRANSACTION_REQUEST,
  EDIT_TRANSACTION_SUCCESS,
  GET_COMPLETED_TRANSACTION_FAILURE,
  GET_COMPLETED_TRANSACTION_REQUEST,
  GET_COMPLETED_TRANSACTION_SUCCESS,
  GET_REJECTED_TRANSACTION_FAILURE,
  GET_REJECTED_TRANSACTION_REQUEST,
  GET_REJECTED_TRANSACTION_SUCCESS,
  GET_TRANSACTION_FAILURE,
  GET_TRANSACTION_REQUEST,
  GET_TRANSACTION_SUCCESS,
} from "./transactionTypes";

let baseUrl = Config.baseUrl;

const getTransactionsRequest = () => {
  return {
    type: GET_TRANSACTION_REQUEST,
  };
};

const getTransactionsSuccess = (payload) => {
  return {
    type: GET_TRANSACTION_SUCCESS,
    payload: payload,
  };
};

const getTransactionsFailure = (error) => {
  return {
    type: GET_TRANSACTION_FAILURE,
    payload: error,
  };
};

const getTransactions = (pageNo, rowsPerPage, search, jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(getTransactionsRequest());
    let url = `${baseUrl}/transaction/get_all?page_number=${
      pageNo + 1
    }&rows_per_page=${rowsPerPage}&search=${search ? search : ""}&download=0`;
    axios
      .get(url, headers)
      .then((response) => {
        dispatch(getTransactionsSuccess(response.data));
      })
      .catch((err) => {
        dispatch(getTransactionsFailure(err.message));
      });
  };
};
const getTransactionsDownloadRequest = () => {
  return {
    type: DOWNLOAD_TRANSACTION_REQUEST,
  };
};

const getTransactionsDownloadSuccess = (payload) => {
  return {
    type: DOWNLOAD_TRANSACTION_SUCCESS,
    payload: payload,
  };
};

const getTransactionsDownloadFailure = (error) => {
  return {
    type: GET_TRANSACTION_FAILURE,
    payload: error,
  };
};

const getTransactionsDownload = (pageNo, rowsPerPage, search, jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(getTransactionsDownloadRequest());
    let url = `${baseUrl}/transaction/get_all?page_number=${
      pageNo + 1
    }&rows_per_page=${rowsPerPage}&search=${search ? search : ""}&download=1`;
    axios
      .get(url, headers)
      .then((response) => {
        dispatch(getTransactionsDownloadSuccess(response.data));
      })
      .catch((err) => {
        dispatch(getTransactionsDownloadFailure(err.message));
      });
  };
};

const getRejectedTransactionsRequest = () => {
  return {
    type: GET_REJECTED_TRANSACTION_REQUEST,
  };
};

const getRejectedTransactionsSuccess = (payload) => {
  return {
    type: GET_REJECTED_TRANSACTION_SUCCESS,
    payload: payload,
  };
};

const getRejectedTransactionsFailure = (error) => {
  return {
    type: GET_REJECTED_TRANSACTION_FAILURE,
    payload: error,
  };
};

const getRejectedTransactions = (pageNo, rowsPerPage, search, jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(getRejectedTransactionsRequest());
    let url = `${baseUrl}/transaction/get_rejected?page_number=${
      pageNo + 1
    }&rows_per_page=${rowsPerPage}&search=${search ? search : ""}&download=0`;
    axios
      .get(url, headers)
      .then((response) => {
        dispatch(getRejectedTransactionsSuccess(response.data));
      })
      .catch((err) => {
        dispatch(getRejectedTransactionsFailure(err.message));
      });
  };
};

const getRejectedTransactionsDownloadRequest = () => {
  return {
    type: DOWNLOAD_REJECTED_TRANSACTION_REQUEST,
  };
};

const getRejectedTransactionsDownloadSuccess = (payload) => {
  return {
    type: DOWNLOAD_REJECTED_TRANSACTION_SUCCESS,
    payload: payload,
  };
};

const getRejectedTransactionsDownloadFailure = (error) => {
  return {
    type: DOWNLOAD_REJECTED_TRANSACTION_FAILURE,
    payload: error,
  };
};

const getRejectedTransactionsDownload = (
  pageNo,
  rowsPerPage,
  search,
  jwtToken,
) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(getRejectedTransactionsDownloadRequest());
    let url = `${baseUrl}/transaction/get_rejected?page_number=${
      pageNo + 1
    }&rows_per_page=${rowsPerPage}&search=${search ? search : ""}&download=1`;
    axios
      .get(url, headers)
      .then((response) => {
        dispatch(getRejectedTransactionsDownloadSuccess(response.data));
      })
      .catch((err) => {
        dispatch(getRejectedTransactionsDownloadFailure(err.message));
      });
  };
};

const editTransactionRequest = () => {
  return {
    type: EDIT_TRANSACTION_REQUEST,
  };
};

const editTransactionSuccess = (payload) => {
  return {
    type: EDIT_TRANSACTION_SUCCESS,
    payload: payload,
  };
};

const editTransactionFailure = (error) => {
  return {
    type: EDIT_TRANSACTION_FAILURE,
    payload: error,
  };
};

const editTransaction = (payload, jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(editTransactionRequest());
    let url = `${baseUrl}/transaction/update_qty`;
    return axios
      .put(url, payload, headers)
      .then((response) => {
        dispatch(editTransactionSuccess(response));
        return { status: true, data: response.data };
      })
      .catch((err) => {
        dispatch(editTransactionFailure(err.response));
        return { status: false, data: err.response };
      });
  };
};

const getCompletedTransactionsRequest = () => {
  return {
    type: GET_COMPLETED_TRANSACTION_REQUEST,
  };
};

const getCompletedTransactionsSuccess = (payload) => {
  return {
    type: GET_COMPLETED_TRANSACTION_SUCCESS,
    payload: payload,
  };
};

const getCompletedTransactionsFailure = (error) => {
  return {
    type: GET_COMPLETED_TRANSACTION_FAILURE,
    payload: error,
  };
};

const getCompletedTransactions = (pageNo, rowsPerPage, search, jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(getCompletedTransactionsRequest());
    let url = `${baseUrl}/transaction/get_completed?page_number=${
      pageNo + 1
    }&rows_per_page=${rowsPerPage}&search=${search ? search : ""}&download=0`;
    axios
      .get(url, headers)
      .then((response) => {
        dispatch(getCompletedTransactionsSuccess(response.data));
      })
      .catch((err) => {
        dispatch(getCompletedTransactionsFailure(err.message));
      });
  };
};

const getCompletedTransactionsDownloadRequest = () => {
  return {
    type: DOWNLOAD_COMPLETED_TRANSACTION_REQUEST,
  };
};

const getCompletedTransactionsDownloadSuccess = (payload) => {
  return {
    type: DOWNLOAD_COMPLETED_TRANSACTION_SUCCESS,
    payload: payload,
  };
};

const getCompletedTransactionsDownloadFailure = (error) => {
  return {
    type: DOWNLOAD_COMPLETED_TRANSACTION_FAILURE,
    payload: error,
  };
};

const getCompletedTransactionsDownload = (
  pageNo,
  rowsPerPage,
  search,
  jwtToken,
) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(getCompletedTransactionsDownloadRequest());
    let url = `${baseUrl}/transaction/get_completed?page_number=${
      pageNo + 1
    }&rows_per_page=${rowsPerPage}&search=${search ? search : ""}&download=1`;
    axios
      .get(url, headers)
      .then((response) => {
        dispatch(getCompletedTransactionsDownloadSuccess(response.data));
      })
      .catch((err) => {
        dispatch(getCompletedTransactionsDownloadFailure(err.message));
      });
  };
};

// const publishPurchaseOrderRequest = () => {
//   return {
//     type: PUBLISH_PURCHASE_ORDER_REQUEST,
//   };
// };

// const publishPurchaseOrderSuccess = (payload) => {
//   return {
//     type: PUBLISH_PURCHASE_ORDER_SUCCESS,
//     payload: payload,
//   };
// };

// const publishPurchaseOrderFailure = (error) => {
//   return {
//     type: PUBLISH_PURCHASE_ORDER_FAILURE,
//     payload: error,
//   };
// };

// const publishPurchaseOrder = (payload, jwtToken) => {
//   let headers = {
//     headers: {
//       Authorization: `Bearer ${jwtToken}`,
//     },
//   };
//   return (dispatch) => {
//     dispatch(publishPurchaseOrderRequest());
//     let url = `${baseUrl}/purchase_order/release`;
//     return axios
//       .put(url, payload, headers)
//       .then((response) => {
//         dispatch(publishPurchaseOrderSuccess(response.data));
//         return { status: true, data: response.data };
//       })
//       .catch((err) => {
//         dispatch(publishPurchaseOrderFailure(err.response));
//         return { status: false, data: err.response };
//       });
//   };
// };

const createTransactionRequest = () => {
  return {
    type: CREATE_TRANSACTION_REQUEST,
  };
};

const createTransactionSuccess = (payload) => {
  return {
    type: CREATE_TRANSACTION_SUCCESS,
    payload: payload,
  };
};

const createTransactionFailure = (error) => {
  return {
    type: CREATE_TRANSACTION_FAILURE,
    payload: error,
  };
};

const createTransaction = (payload, jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(createTransactionRequest());
    let url = `${baseUrl}/transaction/picklist`;
    return axios
      .post(url, payload, headers)
      .then((response) => {
        dispatch(createTransactionSuccess(response.data));
        return { status: true, data: response.data };
      })
      .catch((err) => {
        dispatch(createTransactionFailure(err.response));
        return { status: false, data: err.response };
      });
  };
};

export {
  createTransaction,
  editTransaction,
  getCompletedTransactions,
  getCompletedTransactionsDownload,
  getRejectedTransactions,
  getRejectedTransactionsDownload,
  getTransactions,
  getTransactionsDownload,
};
